import React, { Component, useEffect } from 'react'
import qs from 'qs'
// import extName from 'ext-name'

import { connect } from 'react-redux'

import 'video.js/dist/video-js.css'

import videojs from 'video.js'
import './video.css'
import { useDispatch } from 'react-redux'
import { finishContent } from 'store/Course/actions'

const UrlVideo = (props) => {
  const dispatch = useDispatch()
  let url = ''
  const isYoutube = props.url.includes('youtube.com/watch')
  const isYoutubeShort = props.url.includes('youtube.com/shorts')
  const isVimeo = props.url.includes('vimeo')

  useEffect(() => {
    dispatch(finishContent(props.courseId, props.id))
  }, [dispatch, props.courseId, props.id])

  if (isYoutube) {
    const videoId = new URLSearchParams(new URL(props.url).search).get('v')
    url = `https://www.youtube.com/embed/${videoId}?autoplay=1`
  } else if (isYoutubeShort) {
    const videoId = props.url.split('/shorts/')[1]
    url = `https://www.youtube.com/embed/${videoId}?autoplay=1`
  } else if (isVimeo) {
    const vimeoIdIndex = props.url.indexOf('vimeo.com')
    url = props.url.slice(vimeoIdIndex + 10)
    url = `https://player.vimeo.com/video/${url}?autoplay=1`
  } else if (props.url.includes('google')) {
    url =
      props.url.includes('preview') === false
        ? props.url.replace('view', 'preview')
        : props.url
  } else {
    url = props.url
  }

  return (
    <iframe
      src={url}
      width='100%'
      height='100%'
      frameBorder='0'
      allow='autoplay; encrypted-media'
      allowFullScreen
    ></iframe>
  )
}

class VideoJs extends Component {
  state = {
    tracking: {
      watched: 0,
      duration: 0,
    },
    id: null,
    counter: 0,
    isPlaying: false,
  }

  componentWillReceiveProps(nextProps) {
    const { fullScreen, isShowing } = this.props

    if (!fullScreen) {
      return
    }

    if (!isShowing && nextProps.isShowing) {
      this.toggle('pause')
      return
    }

    if (isShowing && !nextProps.isShowing && this.state.isPlaying) {
      this.toggle('play')
    }
  }

  componentDidMount() {
    this.player = this.videoNode && videojs(this.videoNode, this.props)

    if (this.props.isShowing) {
      this.toggle('pause')

      this.setState({
        isPlaying: true,
      })
    }

    this.setState({
      id: this.props.id,
      url: this.props.url,
    })

    this.player.on('timeupdate', this.timeupdate)
    // this.player.on('seeking', this.seeking)
    this.player.on('ended', this.ended)
    this.player.on('loadedmetadata', this.loaded)
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose()
    }
  }

  toggle = (type) => {
    if (this.player) {
      if (type === 'pause') {
        this.setState({
          isPlaying: !this.player.paused(),
        })
      }

      this.player[type]()
    }
  }
  timeupdate = () => {
    setTimeout(() => {
      const courseStatus = this.props.currentCourse
        ? this.props.currentCourse.status
        : null
      const currentContent = this.props.courseContents.find(
        (item) => item.id === this.props.id
      )

      if (
        this.state.tracking.watched + 1 < this.player.currentTime() &&
        currentContent.restrict_video === 1
      ) {
        this.player.currentTime(this.state.tracking.watched)
        return
      }

      if (this.state.tracking.watched !== this.state.tracking.duration) {
        if (
          this.props.rewatchedVideo.data &&
          this.player.currentTime() <= this.props.rewatchedVideo.data.watched
        ) {
          this.setState({
            tracking: {
              ...this.state.tracking,
              watched: this.props.rewatchedVideo.data.watched,
            },
          })
        } else if (
          (courseStatus && courseStatus > 0) ||
          currentContent.required !== 1
        ) {
          this.setState({
            tracking: {
              ...this.state.tracking,
              watched: this.player.currentTime(),
            },
          })
        } else {
          this.setState({
            tracking: {
              ...this.state.tracking,
              watched: this.player.currentTime(),
            },
            counter: this.state.counter + 1,
          })

          if (
            typeof this.props.onVideoProgress === 'function' &&
            this.state.counter === 40
          ) {
            if (
              this.props.rewatchedVideo.data &&
              this.player.currentTime() >=
                this.props.rewatchedVideo.data.watched
            ) {
              this.props.onVideoProgress(this.state)
              this.setState({ counter: 0 })
            } else if (!this.props.rewatchedVideo.data) {
              this.props.onVideoProgress(this.state)
              this.setState({ counter: 0 })
            }
          }
        }
      }
    }, 0)
  }

  seeking = () => {
    const currentContent = this.props.courseContents.find(
      (item) => item.id === this.props.id
    )

    const disableSeeking = currentContent.required === 1

    if (disableSeeking) {
      console.log('Seeking disabled for this content.')
      this.player.currentTime(this.state.tracking.watched)
    }
  }

  ended = () => {
    if (typeof this.props.onVideoEnd === 'function') {
      this.setState({
        tracking: {
          ...this.state.tracking,
          watched: this.player.currentTime(),
          duration: this.player.duration(),
        },
      })

      this.props.onVideoEnd(this.state)
    }
  }

  loaded = () => {
    this.player.currentTime(this.props.tracking.watched)

    // console.log(this.props.tracking.watched, 'watched')

    this.setState({
      tracking: {
        ...this.state.tracking,
        watched: this.player.currentTime(),
        ...this.props.tracking,
        duration: this.player.duration(),
      },
    })
  }

  render() {
    // console.log(this.state.tracking, 'tracvking')
    return (
      <div style={{ height: '100%' }}>
        {/* {console.log('video')} */}
        <video
          ref={(node) => (this.videoNode = node)}
          className='video-fullscreen video-js vjs-default-skin'
          width='100%'
          height='100%'
          controls
          autoPlay
        >
          <source src={this.props.url} type='video/mp4' />
        </video>
      </div>
    )
  }
}

class Play extends Component {
  state = {
    url: '',
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url) {
      this.props.fetchTrackingByCourseContent(
        this.props.courseId,
        this.props.id
      )

      this.setState({
        url: this.props.url,
      })
    }
  }

  componentDidMount() {
    this.props.fetchTrackingByCourseContent(this.props.courseId, this.props.id)
    this.setState({
      url: this.props.url,
    })
  }

  // componentWillReceiveProps(nextProps) {
  //     if (nextProps.url !== this.props.url) {
  //         this.setState({
  //             url: nextProps.url
  //         })
  //     }
  // }

  render() {
    const split = this.props.content
      ? this.props.content.url.split('.')
      : this.props.url

    const ext = this.props.content
      ? this.props.content.url.indexOf('.com') === -1 && split[split.length - 1]
      : this.props.url.indexOf('.com') === -1 && split[split.length - 1]

    const { videoType } = this.props.content ? this.props.content : this.props
    const data = this.props.content ? this.props.content : this.props

    return (
      <div style={{ height: '100%' }}>
        {videoType === 'url' ? (
          <UrlVideo {...data} />
        ) : data.url === this.state.url &&
          (videoType !== 'url' || (videoType === 'url' && ext)) ? (
          <VideoJs {...data} />
        ) : null}
      </div>
    )
  }
}

// export default connect(({ overlay: { isShowing } }) => ({ isShowing }))(Play)
export default Play
